import { Layout } from '@/components/Layout';
import { SEO } from "@/components/SEO";
import { MissionsPanel } from '@/components/MissionsPanel';
import { useAuth } from '@/hooks/useAuth';

export default function Missions() {
  const { user } = useAuth();

  if (!user) {
    return (
      <Layout>
        <SEO
          title="Missions"
          description="Complete missions to earn coins and unlock rewards on IndieKeys."
        />
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">Login Required</h1>
            <p className="text-muted-foreground">
              You must be logged in to access your missions.
            </p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <SEO
        title="Missions"
        description="Complete missions to earn coins and unlock rewards on IndieKeys."
      />
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Missions</h1>
          <p className="text-muted-foreground">
            Complete missions to earn points and improve your trust score
          </p>
        </div>

        <MissionsPanel playerId={user.id} />
      </div>
    </Layout>
  );
}